import React from "react";
import { Modal, Form } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { createSongs, editSong, getSongs } from "../../Redux/Actions/songs";
import { toast } from "react-toastify";

const CreateSongsModal = ({ page = 0, show, handleClose, selectedSong, songAdded = false }) => {
    const dispatch = useDispatch();

    const initialValues = {
        genre: selectedSong?.genre || "",
        artist: selectedSong?.artist || "",
        title: selectedSong?.title || "",
    };

    const validationSchema = Yup.object({
        genre: Yup.string().required("Genre is required"),
        artist: Yup.string().required("Artist name is required"),
        title: Yup.string().required("Song title is required"),
    });

    function normalizeText(str = "") {
        return str.replace(/[‘’]/g, "'");
    }

    const handleSubmit = (values) => {
        let payload;
        let action;

        if (selectedSong?.fromSongRequest) {
            payload = {
                ...values,
                title: normalizeText(values.title),
                artist: normalizeText(values.artist),
                // Including requestedSongId marks the original request as added,
                // which removes it from the Song Requests list on refresh.
                ...(selectedSong?.requestedSongId
                    ? { requestedSongId: selectedSong.requestedSongId }
                    : {}),
            };
            action = createSongs;
        } else if (selectedSong?._id) {
            payload = { id: selectedSong._id, ...values, title: normalizeText(values.title), artist: normalizeText(values.artist) };
            action = editSong;
        } else {
            payload = { ...values, title: normalizeText(values.title), artist: normalizeText(values.artist) };
            action = createSongs;
        }

        dispatch(action(payload)).then((res) => {
            if (res?.payload?.statusCode === 200) {
                toast.success(action === editSong ? "Song Updated Successfully" : "Song Created Successfully");
                dispatch(getSongs({ page, limit: 50 }));
                handleClose(!!selectedSong?.requestedSongId);
            } else {
                toast.error(res?.payload?.message || "Something went wrong");
            }
        });
    };

    const genreOptions = {
        'Popular/Chart': "Popular_chart",
        'Film/TV': "Film_tv",
        'Jazz': "Jazz",
        'Classical': "Classical",
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header className="border-none justify-content-center">
                <Modal.Title className="mt-3">{selectedSong?._id ? "Update Song" : "Add Song"}</Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ values }) => (
                    <FormikForm>
                        <Modal.Body className="py-0" style={{ position: "relative" }}>
                            <div>
                                <Form.Group className="mb-3">
                                    <Form.Label>Song Title</Form.Label>
                                    <Field
                                        type="text"
                                        name="title"
                                        className="form-control"
                                        placeholder="Enter song title"
                                    />
                                    <ErrorMessage name="title" component="div" className="text-danger" />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Artist</Form.Label>
                                    <Field
                                        type="text"
                                        name="artist"
                                        className="form-control"
                                        placeholder="Enter artist name"
                                    />
                                    <ErrorMessage name="artist" component="div" className="text-danger" />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Genre</Form.Label>
                                    <Field
                                        id="category"
                                        as="select"
                                        name="genre"
                                        className={values.genre === "" ? "form-select placeholder-select" : "form-select filled-select"}
                                        defaultValue=""
                                    >
                                        <option value="" disabled>Select Genre</option>
                                        {Object.entries(genreOptions).map(([key, value]) => (
                                            <option key={value} value={value}>{key}</option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="genre" component="div" className="text-danger" />
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="border-none justify-content-center">
                            <button type="button" className="secondary" onClick={handleClose}>Close</button>
                            <button type="submit" className="primary">{selectedSong?._id ? "Update" : "Add"}</button>
                        </Modal.Footer>
                    </FormikForm>
                )}
            </Formik>
        </Modal>
    );
};

export default CreateSongsModal;
